import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import lockIcon from "../assets/lock-icon.svg";
import { StateService } from "../services/StateService";
import { observer } from "mobx-react-lite";
import "./BidderTable.scss";
import { useState } from "react";
import { useEffect } from "react";
import { autorun } from "mobx";
import {InfoBox} from "./InfoBox";

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: '#212328 !important',
    },
    "&:nth-of-type(even)": {
      backgroundColor: '#1C1E22 !important'
    }
  },
}))(TableRow);

interface BidderTableProps {
  state: StateService;
}

interface TableEntry {
  address: string;
  slots: number;
  bid: number;
  stake: number;
}

const WalletNotAvailable = {
  overlayClass: "overlayBox",
  messageDisplay: "block",
};
const WalletAvailable = { overlayClass: "", messageDisplay: "none" };

export const BidderTable = observer((props: BidderTableProps) => {
  const [me, setMe] = useState(-1);
  const [bidders, setBidders] = useState<TableEntry[]>([]);
  const walletStatus = props.state.web3.getSyncedContract() ? WalletAvailable : WalletNotAvailable;

  useEffect(() => {
    let mounted = true;
    let disposer = autorun(() => {
      let address = props.state.authentication.getAddress();
      let data = props.state.bidStore.getBids();
      let rows: TableEntry[] = [];
      let idx = -1;
      let i = 0;
      data.forEach((value, key) => {
        if (key === address) {
          idx = i;
        }
        rows.push({
          address: key,
          slots: data.get(key)?.slots ?? 0,
          bid: Math.floor(data.get(key)?.deposit ?? 0),
          stake: Math.floor(data.get(key)?.stake ?? 0),
        });
        i++;
      });
      if (mounted) {
        if (idx !== -1){
          setMe(data.size - idx -1);  // need to reverse this label as well
        }
        setBidders(rows.reverse());
      }
    });
    return () => {
      mounted = false;
      disposer();
    };
  }, [props.state.authentication, props.state.bidStore, props.state.web3]);

  return (
    <div className="overlayOuterBox customOverlayBoxes">
      <div className={walletStatus.overlayClass}>
        <TableContainer className="tableContainer" component={Paper}>
          <p style={{ display: "none" }}>{props.state.bidStore.size()}</p>
          <Table className="tableBox" aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell className="cellAddress">
                  Address
                </StyledTableCell>
                {props.state.bidStore.isFinalized()
                    ?
                    <>
                      <StyledTableCell align="center">
                        Staked
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        Unlocked
                      </StyledTableCell>
                    </>
                    :
                    <StyledTableCell align="center">
                      Bid amount
                    </StyledTableCell>
                }
                <StyledTableCell align="center">
                  { props.state.bidStore.isFinalized()
                      ? "Slots"
                      : <div className="predictedSlot">Predicted Slots
                        <InfoBox
                            title="The predicted slots are the bid divided by the current price"
                        />
                        </div> }
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {bidders.map((row, index) => (
                <StyledTableRow
                  key={index}
                  className={index === me ? "rowActive" : ""}
                >
                  <StyledTableCell
                    className="cellOne"
                    component="td"
                    scope="row"
                  >
                    {index === me && <span className="me">Me</span>}
                    {row.address}
                  </StyledTableCell>
                  {props.state.bidStore.isFinalized()
                    ?
                    <>
                      <StyledTableCell align="center">{row.stake}</StyledTableCell>
                      <StyledTableCell align="center">{row.bid - row.stake}</StyledTableCell>
                    </>
                    :
                  <StyledTableCell align="center">{row.bid}</StyledTableCell>
                }
                  <StyledTableCell align="center">{row.slots}</StyledTableCell>
                </StyledTableRow>
              ))}
              {!bidders.length && (
                <StyledTableRow>
                  <StyledTableCell
                    colSpan={3}
                    align="right"
                    className="noData"
                  >There are currently no bids</StyledTableCell>
                </StyledTableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <div
        className="overlayContent"
        style={{ display: walletStatus.messageDisplay }}
      >
        <img src={lockIcon} alt="" />
        <Typography gutterBottom variant="h5" component="h4">
          Connect wallet to see actual bids
        </Typography>
      </div>
    </div>
  );
});
